<template>
  <div id="app" style="overflow: hidden;">
    <router-view/>
  </div>
</template>

<style>
@font-face {
  font-family: "Kanit-Regular";
  src: url("assets/fonts/Kanit-Regular.ttf");
}

#app {
  font-family: 'Kanit-Regular', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>

<script>
export default {
  name: 'app',
  methods: {
    handleResize () {
      this.$store.state.screenWidth = window.innerWidth
      this.$store.state.screenHeight = window.innerHeight
    }
  },
  created () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>